import { NavLink } from "react-router-dom"
import { SITE_INFO } from '../configs/info'

export default function Use() {
    return (
        <>
            {/* Header Section */}
            <section className="bg-[linear-gradient(177.6deg,_rgba(180,0,0,1)_15.3%,_rgba(80,0,0,1)_91.3%)] text-white py-6 sm:py-8 md:py-10">
                <div className="w-[90%] sm:w-[90%] md:w-[85%] m-auto pt-8">
                    <div className="text-center mb-4">
                        <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 text-pink-100 text-xs md:text-sm">
                            <span className="inline-block w-2 h-2 rounded-full bg-pink-400"></span>
                            {SITE_INFO.siteName}
                        </span>
                    </div>
                    {/* Main Title */}
                    <div className="text-center">
                        <h1 className="text-3xl sm:text-4xl md:text-5xl font-black leading-tight text-white drop-shadow-lg">Términos y Condiciones de Uso</h1>
                    </div>
                    {/* Navigation Breadcrumbs */}
                    <div className="text-center mt-3">
                        <span className="text-sm text-white/80"><NavLink to="/" className="transition-all duration-500 hover:text-pink-400">Inicio</NavLink> / <span className="text-white/60">Términos y Condiciones de Uso</span></span>
                    </div>
                </div>
            </section>

            {/* Content Section */}
            <section className="py-6 md:py-8 min-h-[80vh] comment-pricing">
                <div className="w-[90%] sm:w-[90%] md:w-[85%] m-auto">
                    <div className="space-y-6">
                        {/* Section 1 */}
                        <div className="p-5 md:p-6 rounded-2xl bg-white/5 border border-white/10 text-white">
                            <h2 className="text-xl md:text-2xl font-extrabold mb-3">1. Aceptación de los términos</h2>
                            <p className="text-sm md:text-base leading-relaxed text-white/80">
                                Al acceder a nuestro sitio web y utilizar nuestros servicios IPTV, usted acepta los presentes Términos y Condiciones de Uso. Si no está de acuerdo con estos términos, le pedimos que no utilice nuestro sitio ni nuestros servicios.
                            </p>
                        </div>

                        {/* Section 2 */}
                        <div className="p-5 md:p-6 rounded-2xl bg-white/5 border border-white/10 text-white">
                            <h2 className="text-xl md:text-2xl font-extrabold mb-3">2. Servicios IPTV</h2>
                            <p className="text-sm md:text-base leading-relaxed text-white/80">
                                {SITE_INFO.siteName} ofrece suscripciones IPTV para que pueda disfrutar de una amplia variedad de canales y contenidos. Estas suscripciones están diseñadas para ofrecer una experiencia de visualización de calidad sin necesidad de recopilar su información personal.<br />
                                Los códigos de activación y las instrucciones de instalación se le proporcionarán inmediatamente después de su compra.
                            </p>
                        </div>

                        {/* Section 3 */}
                        <div className="p-5 md:p-6 rounded-2xl bg-white/5 border border-white/10 text-white">
                            <h2 className="text-xl md:text-2xl font-extrabold mb-3">3. Privacidad</h2>
                            <p className="text-sm md:text-base leading-relaxed text-white/80">
                                No recopilamos ningún dato personal de nuestros usuarios. Esto significa que su nombre, dirección, información de pago o cualquier otro detalle identificable no es recopilado ni almacenado por {SITE_INFO.siteName}. Su privacidad está garantizada y hemos implementado medidas para evitar cualquier recopilación de datos por parte de terceros.
                            </p>
                            <p className="text-sm md:text-base leading-relaxed pt-2 text-white/80">
                                Al utilizar nuestros servicios, puede estar seguro de que sus actividades permanecen completamente anónimas y seguras.
                            </p>
                        </div>

                        {/* Section 4 */}
                        <div className="p-5 md:p-6 rounded-2xl bg-white/5 border border-white/10 text-white">
                            <h2 className="text-xl md:text-2xl font-extrabold mb-3">4. Pago</h2>
                            <p className="text-sm md:text-base leading-relaxed text-white/80">
                                Los pagos se realizan a través de plataformas seguras de terceros. {SITE_INFO.siteName} no almacena ninguna información de pago. Siga las instrucciones proporcionadas para completar su compra de forma segura.
                            </p>
                        </div>

                        {/* Section 5 */}
                        <div className="p-5 md:p-6 rounded-2xl bg-white/5 border border-white/10 text-white">
                            <h2 className="text-xl md:text-2xl font-extrabold mb-3">5. Uso de los servicios</h2>
                            <p className="text-sm md:text-base leading-relaxed text-white/80">
                                Los servicios IPTV proporcionados por {SITE_INFO.siteName} son para uso personal exclusivamente. No debe compartir, redistribuir ni revender los códigos de activación ni el contenido proporcionado por nuestros servicios. Cualquier uso indebido puede resultar en la cancelación de su suscripción sin reembolso.
                            </p>
                        </div>

                        {/* Section 6 */}
                        <div className="p-5 md:p-6 rounded-2xl bg-white/5 border border-white/10 text-white">
                            <h2 className="text-xl md:text-2xl font-extrabold mb-3">6. Responsabilidad</h2>
                            <p className="text-sm md:text-base leading-relaxed text-white/80">
                                {SITE_INFO.siteName} se compromete a proporcionar servicios IPTV de alta calidad. Sin embargo, no podemos garantizar una disponibilidad ininterrumpida debido a factores externos como fallas de Internet o problemas técnicos. Declinamos toda responsabilidad por interrupciones ajenas a nuestro control.
                            </p>
                        </div>

                        {/* Section 7 */}
                        <div className="p-5 md:p-6 rounded-2xl bg-white/5 border border-white/10 text-white">
                            <h2 className="text-xl md:text-2xl font-extrabold mb-3">7. Derechos de propiedad intelectual</h2>
                            <p className="text-sm md:text-base leading-relaxed text-white/80">
                                Todo el contenido proporcionado por nuestros servicios IPTV, incluidos canales, películas y series, está protegido por derechos de autor y leyes de propiedad intelectual. No debe grabar, distribuir ni copiar este contenido.
                            </p>
                        </div>

                        {/* Section 8 */}
                        <div className="p-5 md:p-6 rounded-2xl bg-white/5 border border-white/10 text-white">
                            <h2 className="text-xl md:text-2xl font-extrabold mb-3">8. Modificaciones de los términos</h2>
                            <p className="text-sm md:text-base leading-relaxed text-white/80">
                                Nos reservamos el derecho de modificar estos términos en cualquier momento. Cualquier modificación será publicada en nuestro sitio web. Al continuar utilizando nuestros servicios después de una modificación, usted acepta los nuevos términos.
                            </p>
                        </div>

                        {/* Section 9 */}
                        <div className="p-5 md:p-6 rounded-2xl bg-white/5 border border-white/10 text-white">
                            <h2 className="text-xl md:text-2xl font-extrabold mb-3">9. Contáctenos</h2>
                            <p className="text-sm md:text-base leading-relaxed mb-4 text-white/80">
                                Para cualquier pregunta sobre esta política de privacidad o para ejercer sus derechos,
                                puede contactarnos a través de:
                            </p>
                            <ul className="list-disc list-inside space-y-2 text-sm md:text-base text-white/90">
                                <li>Correo electrónico: <span className="text-pink-300">contact@tvcielo.com</span></li>
                                <li>
                                    WhatsApp:{" "}
                                    <a
                                        href="https://wa.me/33644657251"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-pink-300 underline hover:text-pink-400"
                                    >
                                        Haga clic aquí para contactarnos
                                    </a>
                                </li>
                            </ul>
                        </div>

                        {/* Conclusion */}
                        <div className="mt-10 pt-6 border-t border-white/10 text-white">
                            <p className="text-sm md:text-base leading-relaxed text-white/80">
                                Gracias por elegir {SITE_INFO.siteName}. Estamos orgullosos de garantizar su privacidad y de
                                ofrecerle un servicio de alta calidad sin comprometer su seguridad o anonimato.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}   
